import { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import {
  CircleNotifications,
  DoneAll,
  ExpandLess,
  ExpandMore,
  Logout,
  People,
  PivotTableChart,
} from '@mui/icons-material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import UndoIcon from '@mui/icons-material/Undo';
import { Box, Collapse, Divider, List, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link, Outlet } from 'react-router-dom';
import { Logo } from '../../components';
import { ClaimIcon, ExcelIcon, InvoiceIcon, ScenarioIcon } from '../../components/icons/CustomIcons';
import { theme } from '../../style/theme';
import { AppVersion } from './components/AppVersion';
import { Content } from './components/Content';
import { AppDrawer } from './components/Drawer';
import { HeaderTag } from './components/HeaderTag';
import { ListItemNavLink } from './components/NavigationsLinks';

const TRANS_NS = 'admin';
export const AdminLayout = () => {
  const { t } = useTranslation(TRANS_NS);
  const [open, setOpen] = useState(true);
  return (
    <Box component={'main'} display={'flex'} flexDirection={'row'} sx={{ flexDirection: { xs: 'column', sm: 'row' } }}>
      <AppDrawer>
        <Box p={4} position={'relative'}>
          <Link to={'/admin'}>
            <Logo width={'100%'} />
          </Link>
          <HeaderTag text={t('admin')} />
        </Box>
        <List>
          <ListItemNavLink to={'/admin'} icon={<AssignmentIcon />} text={t('myTasks')} end />
          <ListItemNavLink to={'/admin/completed-scheduled-actions'} icon={<DoneAll />} text={t('completedTasks')} />
          <ListItemNavLink to={'/admin/invoices'} icon={<InvoiceIcon />} text={t('allInvoices')} />
          <ListItemNavLink to={'/admin/claims'} icon={<ClaimIcon />} text={t('allClaims')} />
          <ListItemNavLink to={'/admin/received-messages'} icon={<MoveToInboxIcon />} text={t('replies')} />
          <ListItemNavLink to={'/admin/users'} icon={<People />} text={t('users')} />
          <ListItemButton onClick={() => setOpen((prev) => !prev)}>
            <ListItemIcon>
              <CircleNotifications />
            </ListItemIcon>
            <ListItemText primary={t('universalReminding.title')} />
            {open ? <ExpandLess color={'action'} /> : <ExpandMore color={'action'} />}
          </ListItemButton>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemNavLink
                isNested
                to={'/admin/universal-reminding/scenarios'}
                icon={<ScenarioIcon />}
                text={t('universalReminding.scenarios')}
              />
              <ListItemNavLink
                isNested
                to={'/admin/universal-reminding/template'}
                icon={<ExcelIcon />}
                text={t('universalReminding.template')}
              />
              <ListItemNavLink
                isNested
                to={'/admin/universal-reminding/data-mapper'}
                icon={<PivotTableChart />}
                text={t('universalReminding.data-mapper')}
              />
            </List>
          </Collapse>
        </List>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            justifyContent: 'flex-end',
          }}
        >
          <Divider />
          <AdminProfileSection />
          <AppVersion />
        </Box>
      </AppDrawer>

      <Content>
        <Outlet />
      </Content>
    </Box>
  );
};

const AdminProfileSection = () => {
  const { user } = useAuth0();
  const { t } = useTranslation(TRANS_NS);
  return (
    <Box display={'flex'} flexDirection={'column'} width={'100%'} pb={0}>
      <Box px={1} pt={4} pb={2} width={'100%'} display={'flex'} flexDirection={'column'} gap={2} alignItems={'center'}>
        <Typography variant={'body2'} color={'secondary.light'}>
          {user?.name}
        </Typography>
      </Box>
      <List>
        <ListItemNavLink to={'/'} icon={<UndoIcon />} text={t('clientApp')} />
        <ListItemNavLink
          to={'/logout'}
          text={
            <Typography
              sx={{
                color: theme.palette.error.main,
              }}
            >
              {t('logout')}
            </Typography>
          }
          icon={<Logout color={'error'} fontSize="small" />}
        />
      </List>
    </Box>
  );
};
